

export const fundingAdminFilters = [
   {
      id: 'status',
      type: 'select',
      name: 'status',
      size: 'large',
      options: [
        {label: 'Σε αναμονή', value: 'PENDING'},
        {label: 'Απορριφθέντα', value: 'REJECTED'},
        {label: 'Εγκεκριμένα', value: 'ACCEPTED'}
        ],
      placeholder: 'Status',
      span: 5,
    },
  {
    id: 'companyName',
    type: 'text',
    name: 'companyName',         
    size: 'medium',
    placeholder: 'Επωνυμία Επιχείρησης',
    span: 5,
    allowClear: true,
  },
  {
    id: 'companyVat',
    type: 'text',
    name: 'companyVat',           
    size: 'medium',
    placeholder: 'ΑΦΜ',
    span: 5,
    allowClear: true,
  },
  {
    id: 'applicationId',
    type: 'text',
    name: 'id',
    size: 'medium',
    placeholder: 'Αρ.Αίτησης',
    span: 5,
    allowClear: true,
  },
]